// extracted by mini-css-extract-plugin
module.exports = {"loaderOverlay":"GeneralLayout_loaderOverlay__FJ86c"};